module.exports = __webpack_public_path__ + "static/media/vaso.84483132.svg";